export default __webpack_public_path__ + "static/media/react-movie-image.f1681b4f.png";